import React, { useState, useEffect, useRef } from 'react';
import _, { isEmpty } from 'lodash';
import classnames from 'classnames';
import { fileLink } from 'common/utils';

import PropTypes from 'prop-types';
import * as css from './SelectImage.scss';
import * as SelectCss from './SelectSongs.scss';

function SelectImage(props) {
	// const breakpoints = {
	// 	tablet: 1024,
	// };

	const [state, setState] = useState({
		cardHidden: [],
		cardDelete: [],
		state: null,
		toggleDrawer: false,
	});

	// const [size, setSize] = useState(0);

	const [stateShowAnimation, setStateShowAnimation] = useState({
		showAnimation: false,
	});

	const [stateDrag] = useState({
		activeDrags: 0,
		deltaPosition: {
			x: 0,
			y: 0,
		},
		controlledPosition: {
			x: 0,
			y: 0,
		},
	});

	const wrapRef = useRef(null);
	const panelContent = useRef(null);

	// useLayoutEffect(() => {
	// 	function updateSize() {
	// 		setSize(window.innerWidth);
	// 	}
	// 	window.addEventListener('resize', updateSize);
	// 	updateSize();
	// 	return () => window.removeEventListener('resize', updateSize);
	// }, []);

	useEffect(() => {
		return () => {
			document.body.classList.remove('not-scroll');
		};
	}, []);

	useEffect(() => {
		setState({ ...state, cardDelete: [] });
		if (isEmpty(props.dataSongsId)) {
			setState({ ...state, cardDelete: [], toggleDrawer: false });
		}
		setStateShowAnimation({
			showAnimation: !isEmpty(props.dataSongsId),
		});

		if (props.openSongPopup) {
			toggleDrawer();
		}
	}, [props]);

	const toggleDrawer = () => {
		// analytics.onMySongsBtnClick();
		if (state.toggleDrawer) {
			document.body.classList.remove('not-scroll');
		} else {
			document.body.classList.add('not-scroll');
		}
		if (stateDrag.controlledPosition.y === 0) {
			setState({ ...state, toggleDrawer: !state.toggleDrawer });
			props.openSongPopupHandler();
		}
		// props.onToggleDrawer(!state.toggleDrawer);
	};

	const deleteItem = id => {
		toggleDrawer();

		props.removeItemForList(id);
	};

	return (
		<div
			className={classnames(
				SelectCss.wrapModal,
				state.toggleDrawer ? SelectCss.open : '',
				props.dataSongsId.length ? '' : SelectCss.hide
			)}
			ref={wrapRef}
		>
			<div className={SelectCss.overSelectSong} onClick={() => toggleDrawer()}></div>
			<div className={classnames(SelectCss.wrapDragPopup, css.selectImageWrapDragPopup)}>
				<div className={classnames(SelectCss.wrapSelect, 'no-cursor')}>
					<div className={classnames(SelectCss.wrapSelectListSong, css.selectImageWrapSelectListSong)}>
						<strong
							className={classnames(
								SelectCss.title,
								css.selectImageTitle,
								stateShowAnimation.showAnimation ? SelectCss.showAnimation : '',
								'cursor'
							)}
							onClick={toggleDrawer}
							// onTouchStart={toggleDrawer}
						>
							<i></i>
							<p>הבחירות שלי</p>
						</strong>

						<div className={classnames(SelectCss.selectSongContent, css.selectImageContent)}>
							<div className={SelectCss.selectSongScroll}>
								<div
									className={classnames(SelectCss.panelContentCustom, css.selectImagePanelCustom)}
									ref={panelContent}
								>
									{!_.isEmpty(props.items) &&
										_.map(props.items, item => {
											return _.map(item, imageItem => {
												if (!imageItem) {
													return null;
												}

												return (
													<div
														className={classnames(
															css.item,
															imageItem.subtitle.length > 0 && css.withSubtitle
														)}
														key={imageItem?.id}
														style={{ backgroundImage: `url(${fileLink(imageItem.file)})` }}
													>
														<div className={css.namesWrapper}>
															<div className={css.itemTitle}>{imageItem.title}</div>
															{imageItem.subtitle && (
																<div className={css.itemSubtitle}>
																	{imageItem.subtitle}
																</div>
															)}
														</div>
														<button
															className={css.delete}
															type="button"
															onClick={() => deleteItem(imageItem?.id)}
														></button>
													</div>
												);
											});
										})}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={SelectCss.fakeClickBlock} onClick={toggleDrawer}></div>
		</div>
	);
}

SelectImage.propTypes = {
	items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	openSongPopup: PropTypes.bool.isRequired,
	dataSongsId: PropTypes.arrayOf(PropTypes.string).isRequired,
	openSongPopupHandler: PropTypes.func.isRequired,
	removeItemForList: PropTypes.func.isRequired,
	// onToggleDrawer: PropTypes.func.isRequired,
};

export default SelectImage;
